// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/producer_profile.sass
// module id = 219
// module chunks = 0